<script setup lang="ts">
const props = defineProps<{
  data: any
  payType: number
  isSmall?: boolean
  disabled?: boolean
}>()
const btnStyle = computed(() => {
  switch (props.data.resource) {
    case 3:
      return {
        background: 'linear-gradient(91deg, #4295FF 4.21%, #0765F1 84.5%)',
        boxShadow: '0px 12px 26px rgba(36, 137, 245, 0.10), 0px 47px 47px rgba(36, 137, 245, 0.09), 0px 105px 63px rgba(36, 137, 245, 0.05), 0px 186px 74px rgba(36, 137, 245, 0.01), 0px 291px 81px rgba(36, 137, 245, 0.00)',
      }
    case 2:
      return {
        background: 'linear-gradient(96deg, #924EF9 9.08%, #671BF8 92.76%)',
        boxShadow: '0px 14px 31px rgba(143, 80, 206, 0.16), 0px 56px 56px rgba(143, 80, 206, 0.14), 0px 126px 75px rgba(143, 80, 206, 0.08), 0px 223px 89px rgba(143, 80, 206, 0.02), 0px 349px 98px rgba(143, 80, 206, 0.00)',
      }
    case 1:
      return {
        background: 'linear-gradient(91deg, #3F4555 4.2%, #16121D 98.67%)',
        boxShadow: '0px 14px 31px rgba(45, 52, 67, 0.16), 0px 56px 56px rgba(45, 52, 67, 0.14), 0px 349px 98px rgba(45, 52, 67, 0.00)',
      }
    default:
      return {
        background: 'linear-gradient(91deg, #4295FF 4.21%, #0765F1 84.5%)',
        boxShadow: '0px 12px 26px rgba(36, 137, 245, 0.10), 0px 47px 47px rgba(36, 137, 245, 0.09), 0px 105px 63px rgba(36, 137, 245, 0.05), 0px 186px 74px rgba(36, 137, 245, 0.01), 0px 291px 81px rgba(36, 137, 245, 0.00)',
      }
  }
})
const btnSmallStyle = computed(() => {
  switch (props.data.resource) {
    case 3:
      return {
        background: 'linear-gradient(91deg, #4396FF 4.2%, #0362F0 98.67%)',
      }
    case 2:
      return {
        background: 'linear-gradient(91deg, #924EFC 4.2%, #5C0EF3 98.67%)',
      }
    case 1:
      return {
        background: 'linear-gradient(93deg, #3F4555 4.1%, #15111C 87.06%)',
      }
    default:
      return {
        background: 'linear-gradient(91deg, #4396FF 4.2%, #0362F0 98.67%)',
      }
  }
})
const style = computed(() => {
  return props.isSmall ? btnSmallStyle.value : btnStyle.value
})
const { userRole, isSubAccount } = useLogin()
const user = useUser()
const userType = computed(() => user.value?.info?.userRole || 3)
function getBtnText(type: number) {
  if (props.disabled) {
    return '已加入企业团队'
  }
  if (userType.value === 3) {
    return type === userType.value ? '立即体验' : '立即购买'
  }
  if (userType.value === 2) {
    return type === userType.value ? '续费购买' : type < userType.value ? '立即购买' : `已开通${userRole.value?.resourceName}`
  }
  if (userType.value === 1) {
    return type === userType.value ? isSubAccount.value ? '继续使用' : '续费购买' : `已开通${userRole.value?.resourceName}`
  }
  return '立即购买'
}
</script>

<template>
  <a-button
    v-bind="$attrs"
    class="w-full flex flex-col rd-32 text-20 font-500 uno-layer-components:!h-48 uno-layer-components:!text-white"
    :class="{ '!text-[--color-text-4] !font-400 !bg-[--color-fill-2]': data.resource > userType || disabled }"
    :disabled="data.resource > userType || disabled"
    :style="data.resource <= userType && !disabled ? style : {}"
  >
    {{ $attrs.label || $t(getBtnText(data.resource)) }}
    <slot />
  </a-button>
</template>

<style lang="less" scoped>

</style>
